export class MapWithDefault extends Map {
    constructor(defaultValueFactory, entries = []) {
        super(entries);
        this.defaultValueFactory = defaultValueFactory;
    }
    get(key) {
        const value = super.get(key);
        return value !== undefined
            ? value
            : this.defaultValueFactory();
    }
}
//# sourceMappingURL=MapWithDefault.js.map